import axios from 'axios';
import { restfulApiConfig } from './config';

const key = restfulApiConfig.apiKey;
let server = 'https://api.webempath.net/v2/analyzeWav';

const post = (wavData): Promise<*> => {
  let formData = new FormData();
  formData.append('apikey', key);
  formData.append('wav', wavData);

  return axios.post(server, formData, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }).then((res) => {
    console.log('Starting Request', res);
    return Promise.resolve(res);
  }).catch((response) => {
    console.log('ERR Request', response);
    return Promise.reject(response);
  })
}


export { post };